import { Button, ButtonProps } from "@mui/material";
import React from "react";

import * as SVGIcons from "../../../../assets/iconsSVG";

const OutlinedButtonGrid: React.FC<ButtonProps> = (props) => {
  return (
    <Button
      {...props}
      style={{
        marginLeft: 8,
        height: 36,
        borderRadius: 4,
      }}
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        background: "#D5DEFF",
        color: "#2D5BFF",
        textTransform: "none",
        fontFamily: "Inter",
        fontWeight: 500,
        boxShadow: "none",
        width: "340px",
        "&:hover": {
          backgroundColor: "#D5DEFF",
          boxShadow: "none",
        },
      }}
      variant="contained"
      startIcon={<SVGIcons.FilterIconGrid />}
    >
      Relatório de leads compartilhados
    </Button>
  );
};

export default OutlinedButtonGrid;
